module.exports = __webpack_public_path__ + "static/img/nav_img1.87b7182a.jpg";